{
  "title": "Línea de Crédito",
  "status": {
    "active": "Activo",
    "frozen": "Congelado",
    "closed": "Cerrado",
    "inactive": "Inactivo",
    "eligible": "Elegible"
  },
  "stats": {
    "basePrincipal": "Principal Base",
    "threshold": "Umbral 3×",
    "creditLimit": "Límite de Crédito",
    "currentBalance": "Saldo Actual",
    "availableCredit": "Crédito Disponible"
  },
  "metrics": {
    "creditLimit": "Límite de Crédito",
    "currentBalance": "Saldo Actual",
    "availableCredit": "Crédito Disponible",
    "interestRate": "Tasa de Interés (APR)",
    "interestPaidYtd": "Intereses Pagados (Año Actual)"
  },
  "messages": {
    "loadingData": "Cargando datos de Línea de Crédito...",
    "featureUnavailable": "Función de Línea de Crédito Temporalmente No Disponible",
    "featureUnavailableDesc": "Los retiros de Línea de Crédito están actualmente deshabilitados. El pago de su deuda continúa automáticamente a través de la asignación diaria de ganancias.",
    "notEligible": "Aún No Elegible",
    "notEligibleDesc": "Necesita alcanzar 3× su principal inicial para activar los retiros de Línea de Crédito.",
    "eligible": "Es elegible para una línea de crédito",
    "eligibleDesc": "Su Principal Base ha alcanzado 3× su contribución inicial. Revise y acepte los términos para activar su línea de crédito.",
    "pendingRequest": "Solicitud de Retiro Pendiente",
    "pendingRequestDesc": "Su solicitud está siendo revisada por un administrador.",
    "termsAccepted": "¡Términos de Línea de Crédito aceptados exitosamente! Su línea de crédito ahora está activa.",
    "mustAcceptTerms": "Debe aceptar los términos de Línea de Crédito primero."
  },
  "buttons": {
    "reviewTerms": "Revisar y Aceptar Términos",
    "requestCredit": "Solicitar Crédito"
  },
  "tooltips": {
    "unavailable": "Línea de Crédito está temporalmente no disponible. El pago continúa normalmente.",
    "frozen": "Su línea de crédito está congelada (cierre de cuenta en progreso).",
    "closed": "Su línea de crédito ha sido cerrada.",
    "noCredit": "No queda crédito disponible."
  },
  "progress": {
    "label": "Progreso",
    "amount": "Monto",
    "status": "Estado",
    "pendingApproval": "Aprobación de Administrador Pendiente"
  }
}
